import { apiRequest } from './api';

export const premisesTypeService = {
    getPremisesTypesByOrgCategory: async (orgCategoryId) => {
        const res = await apiRequest.get('/premises-types', { params: { org_category_id: orgCategoryId } });
        return res.data.data;
    }
};